export default __webpack_public_path__ + "static/media/customer_support.a5dbc2b9.avif";